import { adjustDateWithTimezone } from '@/utils/dates'
import { getNestedValue } from '@/utils/object'
import Vue from 'vue'
import moment from 'moment/moment'
import { getFormattedAddress } from '@/utils/address'
import i18n from '@/i18n'
import { hasInvalidCoords } from '@/utils/map'

export function normalizeBinCollectionItem(vehicle, item) {
  let datetime = adjustDateWithTimezone(getNestedValue(item, 'collectedAt'))
  // FMA 20240318 https://easyredmine.simpliciti.fr/issues/42002
  let vehicleName = Object.keys(vehicle).length
    ? getNestedValue(vehicle, 'name')
    : getNestedValue(item, 'vehicleName')
  let newItem = {
    id: getNestedValue(item, 'id'),
    timestamp: datetime._d.getTime(),
    datetime: datetime._d,
    formattedDate: Vue.$date.formatDate(datetime),
    formattedTime: Vue.$date.formatTimeWithSeconds(datetime),
    timeUnix: moment()
      .hour(datetime.hour())
      .minute(datetime.minute())
      .second(datetime.second()),
    vehicleName:
      item.isOverride && item.complement?.vehicleOverride?.name
        ? item.complement.vehicleOverride.name
        : vehicleName,
    circuitId:
      item.isOverride && item.complement?.roundOverride?.id
        ? item.complement.roundOverride.id
        : getNestedValue(item, 'round.id'),
    circuitName:
      item.isOverride && item.complement?.roundOverride?.shortName
        ? item.complement.roundOverride.shortName
        : getNestedValue(item, 'round.shortName'),
    puceNumber: getNestedValue(item, 'chipNumber'),
    memoryPuceNumber: getNestedValue(item, 'memoryChipNumber'),
    formattedAddress: getFormattedAddress(item, {
      streetNumber: 'streetNumber',
      streetAddress: 'streetName',
      zipCode: 'zipCode',
      city: 'city',
    }),
    chairType: getNestedValue(item, 'side', '', {
      allowZero: true,
      transform(sideNumber, originalValue, rootValue) {
        return normalizeSideValue(sideNumber)
      },
    }),
    isIdentified: !!getNestedValue(item, 'isIdentified', false),
    isStopped: !!getNestedValue(item, 'isStopped', false),
    isHighPoint: getNestedValue(item, 'isHighPoint', false, {
      transform(value, apiValue) {
        if (typeof apiValue !== 'boolean') return 'n/c'
        return !!value //0/1 = false/true
      },
    }),
    isBlacklisted: !!getNestedValue(item, 'isBlacklisted', false),
    weight: getNestedValue(item, 'weight'),
    lat: getNestedValue(item, 'latitude'),
    lng: getNestedValue(item, 'longitude'),
    type: 'bin_collection_marker', //Set type to track click on geometry (see /src/mixins/geometry-click-mixin.js)
  }
  newItem.hasInvalidCoords = hasInvalidCoords({
    lat: newItem.lat,
    lng: newItem.lng,
  })
  return newItem
}

export function normalizeSideValue(value) {
  return (
    {
      0: i18n.t('events.table_column_side_left'), //gauche
      1: i18n.t('events.table_column_side_right'), //droite
      2: i18n.t('events.table_column_side_combine'), //combiné
      3: i18n.t('events.table_column_side_bicomp'), //bicomp
      5: i18n.t('events.table_column_side_arm'), //bras
      9: i18n.t('events.table_column_side_pedestrian'), //pieton
    }[value.toString()] || ''
  )
}
